import { formatTimeStamp } from "util/time"

import { Box, Text, TextProps, Tooltip } from "@chakra-ui/react"
import { DateTime } from "luxon"
import React, { useEffect } from "react"
import ReactTimeago from "react-timeago"

interface Props extends TextProps {
    deadline: number // Epoch timestamp
}

const checkHasExpired = (deadline: number, now: number) => deadline < now

export const Countdown = ({ deadline, ...props }: Props) => {
    const [hasExpired, setHasExpired] = React.useState(checkHasExpired(deadline, DateTime.now().toSeconds()))
    useEffect(() => {
        setInterval(() => {
            setHasExpired(checkHasExpired(deadline, DateTime.now().toSeconds()))
        }, 1000)
    }, [deadline])

    return (
        <Text {...props}>
            {hasExpired ? (
                <Tooltip label={formatTimeStamp(deadline)}>
                    <Box as="span">
                        <Text as="span" color="gray.400" variant="label">
                            {"Expired"}
                        </Text>
                    </Box>
                </Tooltip>
            ) : (
                <>
                    <Text as="span" color="gray.400" variant="label">
                        {"Expires in"}{" "}
                    </Text>
                    <ReactTimeago date={formatTimeStamp(deadline)} />
                </>
            )}
        </Text>
    )
}
